import schoolWebpagesRoutesList from "./schoolWebpagesRoutesList";
import { getRoutes, flattenRoutes } from "Routes/utils";

export const schoolWebpagesRoutes = getRoutes(schoolWebpagesRoutesList);

export const schoolWebpagesFlattenRoutes = flattenRoutes(
  schoolWebpagesRoutesList,
);
